"use strict";exports.__esModule = true;exports.createPropsGetter = createPropsGetter;



// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint, @typescript-eslint/no-unused-vars
function createPropsGetter(defaultProps) {
  return function () {
    return this.props;
  };
}